import { api } from "./api";

export const pushSupported = () =>
  typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

async function getReg() {
  if (navigator.serviceWorker.controller) return navigator.serviceWorker.ready;
  try { await navigator.serviceWorker.register("/sw.js"); } catch (e) { console.debug("SW register failed", e); }
  return navigator.serviceWorker.ready;
}

// Subscribe & persist. If requestPermission is false, only proceeds when permission is already granted.
export async function enablePush({ orderToken = null, requestPermission = true } = {}) {
  if (!pushSupported()) throw new Error("Notifiche non supportate su questo browser.");
  let perm = Notification.permission;
  if (perm !== "granted") {
    if (!requestPermission) return null;
    perm = await Notification.requestPermission();
  }
  if (perm !== "granted") throw new Error("Permesso notifiche negato.");

  const reg = await getReg();
  const { data } = await api.get("/push/vapid-public-key");
  if (!data?.publicKey) throw new Error("Chiave push non disponibile.");

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: json.endpoint,
    keys: json.keys,
    expirationTime: json.expirationTime || null,
    order_token: orderToken,
  });
  return sub;
}

export async function isPushEnabled() {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    return !!(await reg.pushManager.getSubscription());
  } catch (_) { return false; }
}

export async function disablePush() {
  if (!pushSupported()) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      const endpoint = sub.endpoint;
      try { await sub.unsubscribe(); } catch (e) { console.debug("push unsubscribe failed", e); }
      try { await api.post("/push/unsubscribe", { endpoint }); } catch (e) { console.debug("push unsubscribe api failed", e); }
    }
  } catch (e) { console.debug("disablePush failed", e); }
}
